export type CodeRanges = ReadonlyArray<readonly [number, number]>

export const PINYON: CodeRanges = [
  [13, 13],
  [32, 126],
  [160, 172],
  [174, 328],
  [330, 383],
  [385, 385],
  [393, 394],
  [398, 399],
  [402, 402],
  [408, 409],
  [416, 417],
  [431, 432],
  [435, 438],
  [452, 483],
  [486, 491],
  [497, 501],
  [504, 539],
  [542, 543],
  [550, 563],
  [567, 567],
  [581, 581],
  [595, 595],
  [598, 599],
  [601, 601],
  [652, 652],
  [710, 711],
  [728, 733],
  [768, 772],
  [774, 780],
  [783, 783],
  [785, 786],
  [795, 795],
  [803, 808],
  [813, 814],
  [816, 817],
  [7680, 7735],
  [7738, 7829],
  [7831, 7831],
  [7838, 7838],
  [7840, 7929],
  [8192, 8203],
  [8205, 8205],
  [8209, 8209],
  [8211, 8212],
  [8216, 8218],
  [8220, 8222],
  [8224, 8226],
  [8230, 8230],
  [8239, 8239],
  [8242, 8243],
  [8249, 8250],
  [8260, 8260],
  [8287, 8287],
  [8308, 8308],
  [8364, 8364],
  [8470, 8470],
  [8482, 8482],
  [8494, 8494],
  [8531, 8532],
  [8722, 8722],
  [8800, 8800],
  [9676, 9676],
  [42891, 42892],
  [64257, 64258],
]

export const BASKERVILLE: CodeRanges = [
  [32, 126],
  [160, 172],
  [174, 328],
  [330, 382],
  [384, 385],
  [390, 394],
  [398, 403],
  [406, 410],
  [413, 413],
  [420, 421],
  [425, 425],
  [428, 430],
  [434, 438],
  [452, 493],
  [496, 501],
  [504, 539],
  [542, 543],
  [550, 563],
  [567, 567],
  [570, 574],
  [577, 591],
  [593, 593],
  [595, 596],
  [598, 599],
  [601, 601],
  [603, 603],
  [608, 608],
  [613, 614],
  [616, 617],
  [619, 619],
  [626, 626],
  [637, 638],
  [643, 643],
  [648, 649],
  [651, 652],
  [660, 661],
  [700, 700],
  [702, 703],
  [710, 711],
  [728, 733],
  [768, 772],
  [774, 776],
  [778, 780],
  [783, 783],
  [785, 786],
  [803, 808],
  [813, 814],
  [816, 817],
  [821, 824],
  [956, 956],
  [7549, 7549],
  [7680, 7834],
  [7838, 7838],
  [7840, 7841],
  [7852, 7853],
  [7862, 7865],
  [7868, 7869],
  [7878, 7879],
  [7882, 7885],
  [7896, 7897],
  [7908, 7909],
  [7922, 7925],
  [7928, 7929],
  [8211, 8212],
  [8216, 8218],
  [8220, 8222],
  [8224, 8226],
  [8230, 8230],
  [8232, 8233],
  [8240, 8240],
  [8249, 8250],
  [8260, 8260],
  [8304, 8304],
  [8308, 8313],
  [8320, 8329],
  [8356, 8356],
  [8364, 8364],
  [8373, 8373],
  [8470, 8470],
  [8480, 8480],
  [8482, 8482],
  [8531, 8532],
  [8539, 8542],
  [8722, 8722],
  [8725, 8725],
  [8729, 8729],
  [8800, 8800],
  [11360, 11366],
  [11373, 11373],
  [11378, 11379],
  [42816, 42817],
  [42891, 42893],
  [42898, 42899],
  [42922, 42922],
  [63171, 63171],
  [64256, 64260],
  [64262, 64262],
]

export const BASKERVILLE_BOLD: CodeRanges = [
  [32, 126],
  [160, 172],
  [174, 328],
  [330, 382],
  [384, 385],
  [390, 394],
  [398, 403],
  [406, 410],
  [413, 413],
  [420, 421],
  [425, 425],
  [428, 430],
  [434, 438],
  [452, 493],
  [496, 501],
  [504, 539],
  [542, 543],
  [550, 563],
  [567, 567],
  [570, 574],
  [577, 591],
  [593, 593],
  [595, 596],
  [598, 599],
  [601, 601],
  [603, 603],
  [608, 608],
  [613, 614],
  [616, 617],
  [619, 619],
  [626, 626],
  [637, 638],
  [643, 643],
  [648, 649],
  [651, 652],
  [660, 661],
  [700, 700],
  [702, 703],
  [710, 711],
  [728, 733],
  [768, 772],
  [774, 776],
  [778, 780],
  [783, 783],
  [785, 786],
  [803, 808],
  [813, 814],
  [816, 817],
  [821, 824],
  [956, 956],
  [7549, 7549],
  [7680, 7834],
  [7838, 7838],
  [7840, 7841],
  [7852, 7853],
  [7862, 7865],
  [7868, 7869],
  [7878, 7879],
  [7882, 7885],
  [7896, 7897],
  [7908, 7909],
  [7922, 7925],
  [7928, 7929],
  [8211, 8212],
  [8216, 8218],
  [8220, 8222],
  [8224, 8226],
  [8230, 8230],
  [8232, 8233],
  [8240, 8240],
  [8249, 8250],
  [8260, 8260],
  [8304, 8304],
  [8308, 8313],
  [8320, 8329],
  [8356, 8356],
  [8364, 8364],
  [8373, 8373],
  [8470, 8470],
  [8480, 8480],
  [8482, 8482],
  [8531, 8532],
  [8539, 8542],
  [8722, 8722],
  [8725, 8725],
  [8729, 8729],
  [8800, 8800],
  [11360, 11366],
  [11373, 11373],
  [11378, 11379],
  [42816, 42817],
  [42891, 42893],
  [42898, 42899],
  [42922, 42922],
  [63171, 63171],
  [64256, 64260],
  [64262, 64262],
]

export const CARLITO: CodeRanges = [
  [0, 255],
  [305, 305],
  [338, 339],
  [699, 700],
  [710, 710],
  [730, 730],
  [732, 732],
  [772, 772],
  [776, 776],
  [809, 809],
  [8192, 8303],
  [8364, 8364],
  [8482, 8482],
  [8593, 8593],
  [8595, 8595],
  [8722, 8722],
  [8725, 8725],
  [65279, 65279],
  [65533, 65533],
]

export const NOTO_SERIF: CodeRanges = [
  [0, 0],
  [13, 13],
  [32, 126],
  [160, 887],
  [890, 895],
  [900, 906],
  [908, 908],
  [910, 929],
  [931, 993],
  [1008, 1327],
  [4347, 4347],
  [6832, 6848],
  [6853, 6853],
  [6855, 6862],
  [7296, 7304],
  [7424, 7673],
  [7675, 7957],
  [7960, 7965],
  [7968, 8005],
  [8008, 8013],
  [8016, 8023],
  [8025, 8025],
  [8027, 8027],
  [8029, 8029],
  [8031, 8061],
  [8064, 8116],
  [8118, 8132],
  [8134, 8147],
  [8150, 8155],
  [8157, 8175],
  [8178, 8180],
  [8182, 8190],
  [8192, 8292],
  [8294, 8305],
  [8308, 8334],
  [8336, 8348],
  [8352, 8384],
  [8432, 8432],
  [8448, 8543],
  [8579, 8580],
  [8585, 8585],
  [8722, 8722],
  [9676, 9676],
  [11360, 11391],
  [11744, 11869],
  [42560, 42655],
  [42752, 42954],
  [42960, 42961],
  [42963, 42963],
  [42965, 42969],
  [42994, 43007],
  [43310, 43310],
  [43824, 43883],
  [64256, 64262],
  [65024, 65024],
  [65056, 65071],
  [65279, 65279],
  [65532, 65533],
  [67456, 67461],
  [67463, 67504],
  [67506, 67514],
  [122624, 122654],
]

export const NOTO_SERIF_BOLD: CodeRanges = [
  [0, 0],
  [13, 13],
  [32, 126],
  [160, 887],
  [890, 895],
  [900, 906],
  [908, 908],
  [910, 929],
  [931, 993],
  [1008, 1327],
  [4347, 4347],
  [6832, 6848],
  [6853, 6853],
  [6855, 6862],
  [7296, 7304],
  [7424, 7673],
  [7675, 7957],
  [7960, 7965],
  [7968, 8005],
  [8008, 8013],
  [8016, 8023],
  [8025, 8025],
  [8027, 8027],
  [8029, 8029],
  [8031, 8061],
  [8064, 8116],
  [8118, 8132],
  [8134, 8147],
  [8150, 8155],
  [8157, 8175],
  [8178, 8180],
  [8182, 8190],
  [8192, 8292],
  [8294, 8305],
  [8308, 8334],
  [8336, 8348],
  [8352, 8384],
  [8432, 8432],
  [8448, 8543],
  [8579, 8580],
  [8585, 8585],
  [8722, 8722],
  [9676, 9676],
  [11360, 11391],
  [11744, 11869],
  [42560, 42655],
  [42752, 42954],
  [42960, 42961],
  [42963, 42963],
  [42965, 42969],
  [42994, 43007],
  [43310, 43310],
  [43824, 43883],
  [64256, 64262],
  [65024, 65024],
  [65056, 65071],
  [65279, 65279],
  [65532, 65533],
  [67456, 67461],
  [67463, 67504],
  [67506, 67514],
  [122624, 122654],
]

export const FONT_METRICS: Record<string, {ascent: number; descent: number}> = {
  'Carlito-Regular': {ascent: 0.95215, descent: 0.26855},
  'LibreBaskerville-Bold': {ascent: 0.97, descent: 0.27},
  'LibreBaskerville-Regular': {ascent: 0.97, descent: 0.27},
  'NotoNaskhArabic-Regular': {ascent: 1.069, descent: 0.634},
  'NotoSerif-Bold': {ascent: 1.069, descent: 0.293},
  'NotoSerif-Regular': {ascent: 1.069, descent: 0.293},
  'NotoSerifDevanagari-Regular': {ascent: 0.93, descent: 0.625},
  'NotoSerifEthiopic-Regular': {ascent: 1.069, descent: 0.293},
  'NotoSerifHebrew-Regular': {ascent: 0.896, descent: 0.29},
  'PinyonScript-Regular': {ascent: 0.86328, descent: 0.38428},
}
